import React from 'react'

const FeedContext = React.createContext<any>({})

export const FeedProvider = ({withAdventureRef, children}: any) => {
	const value = {
		withAdventureRef
	}

	return (
		<FeedContext.Provider value={value}>
			{children}
		</FeedContext.Provider>
	)
}
export const FeedConsumer = FeedContext.Consumer
export default FeedContext
